import { gql } from "@apollo/client";

export const enableOrganizaiton = gql`
    mutation EnableOrganization($orgId: String, $token: String) {
        enableCameraKitOrganization(input: { orgId: $orgId, token: $token }) {
            _
        }
    }
`;
